export default class CustomEmailTemplateService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  async create(customEmailTemplate, options) {
    const response = await fetch(`${this.baseUrl}/customEmailTemplate`, {
      body: JSON.stringify(customEmailTemplate),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    if (!response.ok) {
      throw await toError(response)
    }

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUrl}/customEmailTemplate/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUrl}/customEmailTemplate/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUrl}/customEmailTemplate`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, customEmailTemplate, options) {
    const response = await fetch(`${this.baseUrl}/customEmailTemplate/${id}`, {
      body: JSON.stringify(customEmailTemplate),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    if (!response.ok) {
      throw await toError(response)
    }

    return true
  }

  // --- Designer ---

  async render(request, options) {
    const response = await fetch(`${this.baseUrl}/customEmailTemplate/render`, {
      body: JSON.stringify(request),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    if (!response.ok) {
      throw await toError(response)
    }

    return await response.json()
  }

  async sendTest(id, request, options) {
    const response = await fetch(`${this.baseUrl}/customEmailTemplate/${id}/send-test`, {
      body: JSON.stringify(request),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    if (!response.ok) {
      throw await toError(response)
    }

    return true
  }

  async duplicate(id, request, options) {
    const response = await fetch(`${this.baseUrl}/customEmailTemplate/${id}/duplicate`, {
      body: JSON.stringify(request || {}),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    if (!response.ok) {
      throw await toError(response)
    }

    return await response.json()
  }

  async convert(id, options) {
    const response = await fetch(`${this.baseUrl}/customEmailTemplate/${id}/convert`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'POST'
    })

    if (!response.ok) {
      throw await toError(response)
    }

    return await response.json()
  }

  async getPlaceholders(options) {
    return await getJson(`${this.baseUrl}/customEmailTemplate/placeholders`, options)
  }

  async getCallToActionTargets(options) {
    return await getJson(`${this.baseUrl}/customEmailTemplate/call-to-action-targets`, options)
  }

  async getSettings(options) {
    return await getJson(`${this.baseUrl}/customEmailTemplate/settings`, options)
  }
}

async function getJson(url, options) {
  const response = await fetch(url, {
    headers: {
      'Authorization': `Bearer ${options.accessToken}`
    }
  })

  if (!response.ok) {
    throw await toError(response)
  }

  return await response.json()
}

async function toError(response) {
  let errors = []

  try {
    const body = await response.json()
    errors = body.errors || (body.message ? [ body.message ] : [])
  } catch (e) {
    // kein JSON-Body
  }

  const error = new Error(errors.length ? errors.join('\n') : `HTTP ${response.status}`)
  error.status = response.status
  error.errors = errors

  return error
}
